/* eslint-disable react/jsx-one-expression-per-line */
import React, { useEffect } from 'react';
import { AlertIconSuccess, IconFlag } from '~/presentation/base/icons';
import { iMessage } from '~/domain/interfaces/models';
import {
  IconButton,
  Typography,
  Button,
} from '@wisecare-tech/design-system-web';
import { MessageOptions } from '~/domain/interfaces/redux/message';
import { makeRemoteListOnCall } from '~/main/factories/usecases/duty/ListOnCall';
import {
  ContainerModal,
  Container,
  Content,
  Icon,
  Title,
  Information,
  Info,
  Footer,
  Header,
  Profession,
  Data,
  Priority,
} from './styles/styles';
import { AlertMessage } from '../messages/AlertMessage';
import { priorityMap } from '~/utils/mapPriority';

interface iPropsModalConsultationRequest {
  message: iMessage;
}

const ModalConsultationRequest: React.FC<iPropsModalConsultationRequest> = ({
  message,
}) => {
  const { active, actionCancel, appointmentSpecialty, data } = message;

  const [specialty, setSpecialty] = React.useState<string>();

  const msgName = MessageOptions.consultationRequestSuccess;

  useEffect(() => {
    if (active !== msgName) return;

    makeRemoteListOnCall()
      .get({})
      .then(res => {
        const selectedSpecialty = res?.records?.find(
          item => item?.id === Number(appointmentSpecialty),
        );
        setSpecialty(selectedSpecialty?.descr);
      })
      .catch(() => {
        AlertMessage({
          message: 'Falha ao carregar especialidades!',
          type: 'danger',
        });
      });
  }, [active, appointmentSpecialty, msgName]);

  return (
    <>
      {msgName === active && (
        <ContainerModal>
          <Container>
            <Content>
              <Header>
                <Icon>
                  <AlertIconSuccess />
                </Icon>
                <IconButton
                  icon="close"
                  variant="primary"
                  size="sm"
                  onClick={actionCancel}
                />
              </Header>
              <Title>
                Sua solicitação de interconsulta de acompanhamento foi enviada!
              </Title>

              <Information>
                <Info>
                  Sua solicitação de interconsulta com um profissional do
                  plantão de {`${specialty ?? ''}`} foi enviada com sucesso.
                </Info>
                <Info>
                  Lembre-se: não será necessário refazê-la se nenhum
                  profissional estiver disponível no momento.
                </Info>
              </Information>
            </Content>
            <Profession>
              <Data>
                <Typography variant="t4_16medium">Profissão:</Typography>
                <Typography variant="b1_16regular">
                  {data?.profession}
                </Typography>
              </Data>
              <Data>
                <Typography variant="t4_16medium">Especialidade:</Typography>
                <Typography variant="b1_16regular">{specialty}</Typography>
              </Data>
              <Data>
                <Typography variant="t4_16medium">Prioridade:</Typography>
                <Typography variant="b1_16regular">
                  <Priority priority={data?.priority}>
                    <IconFlag />
                    {priorityMap(data?.priority)}
                  </Priority>
                </Typography>
              </Data>
            </Profession>
            <Footer>
              <Button variant="primary" onClick={actionCancel}>
                Entendi
              </Button>
            </Footer>
          </Container>
        </ContainerModal>
      )}
    </>
  );
};

export default ModalConsultationRequest;
